import { render, staticRenderFns } from "./RegisterUserTermsForm.vue?vue&type=template&id=2792106e&scoped=true"
import script from "./RegisterUserTermsForm.vue?vue&type=script&lang=js"
export * from "./RegisterUserTermsForm.vue?vue&type=script&lang=js"
import style0 from "./RegisterUserTermsForm.vue?vue&type=style&index=0&id=2792106e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2792106e",
  null
  
)

export default component.exports